const tr = {
  appointmentRating: {
    attributes: {
      id: 'ID',
      name: 'Nome',
      corporation: 'Empresa',
      rated_at: 'Data Atendimento',
      hour: 'Hora Atendimento',
      rating: 'Avaliação',
      period: 'Período',
      week_day: 'Dia da Semana',
      observation: 'Observação',
      attendant_name: 'Atendente avaliado',
      doctor_name: 'Médico avaliado',
    },
    extras: {
      date_init: 'Data inicial',
      date_end: 'Data final',
      search: 'Digite o nome ou CPF',
      type: 'Tipo',
    },
  },
};

export default tr;
